import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './Modal.module.sass'
import WModal from '../WModal/WModal'
import useTrans from '@hooks/useTrans'
import { Close } from '@components/icons'


interface Props {
  id: string
  open: boolean
  title?: string
  subtitle?: string
  description?: string
  buttons?: React.ReactNode
  children?: React.ReactNode
  onClose?: () => void
  className?: string
  mainClassName?: string
  headerClassName?: string
  bodyClassName?: string
  buttonsClassName?: string
  closeClassName?: string
}

const Modal = (props: Props) => {

  const { 
    id,
    open,
    onClose,
    title,
    subtitle,
    description,
    buttons,
    children,
    className,
    mainClassName,
    headerClassName,
    bodyClassName,
    buttonsClassName,
    closeClassName,
  } = props

  
  const t = useTrans()
  const titleId = `${id}-title`
  const descriptionId = description ? `${id}-description` : undefined

  return (
    <WModal
      id={id}
      className={cn(styles.root, className)}
      open={open}
      onClose={onClose}
      ariaLabelledby={titleId}
    >
      <section className={cn(styles.main, mainClassName)} aria-describedby={descriptionId}>
        {onClose ? (
          <button
            type="button"
            className={cn(styles.closeButton, closeClassName)}
            onClick={onClose}
            aria-label={t("Chiudi")}
          >
            <Close aria-hidden />
          </button>
        ) : null}

        <header className={cn(styles.header, headerClassName)}>
          <h2 id={titleId} className={styles.title}>
            {title}
          </h2>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </header>

        {!!children && (
          <div className={cn(styles.body, bodyClassName)}>
            {!!description && (
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
            )}
            {children}
          </div>
        )}

        {!!buttons && (
          <div className={cn(styles.ctaBar, buttonsClassName)}>
            {buttons}
          </div>
        )}

      </section>
    </WModal>
  )
}

export default Modal
